import { render, staticRenderFns } from "./TryFramework.vue?vue&type=template&id=d126ce54&scoped=true&"
import script from "./TryFramework.vue?vue&type=script&lang=js&"
export * from "./TryFramework.vue?vue&type=script&lang=js&"
import style0 from "./TryFramework.vue?vue&type=style&index=0&id=d126ce54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d126ce54",
  null
  
)

export default component.exports